import { KYCWorkflowsTable } from './components/KYCWorkflowsTable.tsx';

export const ManageKYC = () => {
	return <KYCWorkflowsTable />;
};
